import React, { useState, useEffect } from 'react';
import { ConstructorEventUpdateSQLStatus } from "../../../../Event/event";

const LemonadeStandTycoon = () => {
  const [cost, setCost] = useState(0);
  const [sell, setSell] = useState(0);
  const [input, setInput] = useState('');
  const [message, setMessage] = useState('');
  const [messageColor, setMessageColor] = useState('#2e7d32');

  const generateScenario = () => {
    const costOptions = [10, 12, 15, 18, 20];
    const sellOptions = [22, 25, 28, 30];

    const newCost = costOptions[Math.floor(Math.random() * costOptions.length)];
    const newSell = sellOptions[Math.floor(Math.random() * sellOptions.length)];

    setCost(newCost);
    setSell(newSell);
    setInput('');
    setMessage('');
  };

  const checkProfit = () => {
    const parsedInput = parseFloat(input);
    const correct = sell - cost;

    if (isNaN(parsedInput)) {
      setMessage('❗ Please enter a number!');
      setMessageColor('#d32f2f');
    } else if (parsedInput === correct) {
      setMessage(`🎉 Correct! Your profit is $${correct}`);
         const responsedata = ConstructorEventUpdateSQLStatus();
      console.log("Event completed", responsedata);
      setMessageColor('#2e7d32');
    } else {
      setMessage(`🚫 Oops! Try again. Hint: $${sell} – $${cost}`);
      setMessageColor('#d32f2f');
    }
  };

  useEffect(() => {
    generateScenario();
  }, []);

  const styles = {
    body: {
      margin: 0,
      padding: 0,
      fontFamily: "'Comic Sans MS', cursive",
      background: "linear-gradient(to bottom right, #fffacd, #ffe4b5)",
      color: "#333",
      textAlign: "center",
      minHeight: "100vh",
    },
    header: {
      background: "#fdd835",
      padding: "25px",
      fontSize: "30px",
      color: "#444",
      fontWeight: "bold",
      boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    },
    container: {
      maxWidth: "700px",
      margin: "40px auto",
      padding: "20px",
      background: "#ffffff",
      borderRadius: "15px",
      boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
    },
    scenario: {
      fontSize: "20px",
      marginBottom: "20px",
    },
    input: {
      padding: "10px",
      fontSize: "16px",
      width: "120px",
      margin: "10px",
      borderRadius: "8px",
      border: "1px solid #ccc",
    },
    button: {
      padding: "12px 25px",
      fontSize: "18px",
      border: "none",
      borderRadius: "10px",
      backgroundColor: "#fbc02d",
      color: "#333",
      cursor: "pointer",
      margin: "10px",
    },
    result: {
      marginTop: "20px",
      fontSize: "22px",
      fontWeight: "bold",
      color: messageColor,
    },
    lemonGif: {
      width: "80px",
      marginBottom: "20px",
    },
  };

  return (
    <div style={styles.body}>
      <div style={styles.header}>🍋 Lemonade Stand Tycoon</div>
      <div style={styles.container}>
       
        <div style={styles.scenario}>
          You bought ingredients for <strong>${cost}</strong> and sold lemonade for{' '}
          <strong>${sell}</strong>. What is your profit?
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
  <input
    type="number"
    value={input}
    onChange={(e) => setInput(e.target.value)}
    placeholder="Your Profit $"
    style={styles.input}
  />
</div>

        <button onClick={checkProfit} style={styles.button}>Check Answer ✅</button>
        <button onClick={generateScenario} style={styles.button}>Next Round 🔄</button>
        <div style={{ ...styles.result, color: messageColor }}>{message}</div>
      </div>
    </div>
  );
};

export default LemonadeStandTycoon;
